export class FatalTypeScriptError extends Error {}
